import { createSelector } from 'reselect';

const totesObservacions = (state) => {
    if (!state.observacio.totes) {
        return null;
    }

    return state.observacio.totes.observacions;
};
const codiEstacio = (state) => state.observacio.detall;

const obtenirDetallObservacio = (totesObservacions, codiEstacio) => {
    if (!codiEstacio || !totesObservacions) {
        return null;
    }

    const observacioTrobada = totesObservacions.find(function (observacio) {
        return (observacio.estacio.codi === codiEstacio);
    });

    return observacioTrobada || null;
};

const selector = createSelector(
    totesObservacions,      //Totes les observacions
    codiEstacio,

    obtenirDetallObservacio
);
export default selector;



// WEBPACK FOOTER //
// ./src/selectors/selector_observacio_per_codi.js